import config from 'config';
import moment from 'moment';
import request from 'helpers/superagent';
import chain from '@ersinfotech/chain';
import _ from 'lodash';
import {fetchWechatArticleSuccess} from './actions';

export const fetchWechatArticle = (data) => {
  const {access_token} = localStorage;
  return request.post(config.edata.baseUrl + '/graphql')
      .query({
        access_token
      })
      .send({
        query: `
          query (
            $subjectId: String
            $limit: Int
            $offset: Int
            $mediaType: [MediaTypeEnum]
            $from: [String]
            $sort: SortEnum
            $hasImage: Boolean
            $startDate: String
            $endDate: String
          ) {
            search(
              subjectId: $subjectId
              limit: $limit
              offset: $offset
              mediaType: $mediaType
              from: $from
              sort: $sort
              hasImage: $hasImage
              startDate: $startDate
              endDate: $endDate
            ) {
              count
              took
              data{
                ... on News {
                  globalId
                  mediaType
                  date
                  title
                  content
                  from
                  in
                  by
                  isTraditional
                  images
                  url
                }
                ... on Wechat {
                  globalId
                  mediaType
                  date
                  title
                  content
                  from
                  by
                  images
                  hits
                  likes
                  words
                  score
                  url
                  abstract
                }
              }
            }
          }
        `,
        variables: data,
      })
      .endAsync()
      .get('body')
      .then(body => {
        return fetchWechatArticleSuccess(_.get(body, 'data.search.data'))
      });
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/carousel/tasks.js
 **/